import React from "react";
import { TorahAnytimeCreatePlaylistTemplate } from "themes/application/torah-anytime/components";
import { TorahAnytimeCollectionEditViewStore } from "application/torah-anytime/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new TorahAnytimeCollectionEditViewStore(rootStore, componentProps),
    "torahAnytimeCollectionEditViewStore"
)
class TorahAnytimeCreatePlaylist extends React.Component {
    render() {
        return <TorahAnytimeCreatePlaylistTemplate {...this.props} />;
    }
}

export default TorahAnytimeCreatePlaylist;
